import { KeyboardOutlinedIcon, ScannerIcon } from "./iconography";

export const BarcodeInputIcon = ({ isScanned }) => {
  return isScanned ? (
    <ScannerIcon fontSize="small" />
  ) : (
    <KeyboardOutlinedIcon fontSize="small" />
  );
};
